export const PRIVY_COMPATIBLE_SOCIAL_NETWORK = ['google', 'twitter'];
const SOCIAL_WALLET_IMAGE_BASE_URL = 'https://app.rango.exchange';
export const DEFAULT_SOCIAL_WALLET_IMAGE = `${SOCIAL_WALLET_IMAGE_BASE_URL}/imgs/wallets/social-wallet-email.svg`;
export const SOCIAL_WALLET_IMAGE_BY_SOCIAL_NETWORKS = {
    google: `${SOCIAL_WALLET_IMAGE_BASE_URL}/imgs/wallets/social-wallet-google.svg`,
    twitter: `${SOCIAL_WALLET_IMAGE_BASE_URL}/imgs/wallets/social-wallet-twitter.svg`,
};
export const SOCIAL_WALLET_INTRO_CONFIRMED = 'social-wallet-intro-confirmed';
